const styles = () => ({
  statusPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#FEEFEC',
    minHeight: '100vh',
  },
  logoImage: {
    maxWidth: '164px',
    marginTop: '39px',
  },
  statusContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '566px',
    margin: '0 15px',

    '& h2': {
      fontSize: '60px',
      lineHeight: '40px',
      color: '#000000',
      fontWeight: '800',
      margin: 0,

      '@media (max-width: 767px)': {
        fontSize: '30px',
        lineHeight: '40px',
      },
    },

    '& p': {
      fontSize: '20px',
      lineHeight: '24px',
      color: '#000000',
      marginTop: '36px',

      '@media (max-width: 767px)': {
        fontSize: '16px',
        lineHeight: '18px',
        textAlign: 'center',
        marginTop: '20px',
      },
    },

    '& a': {
      color: '#000',
    },
  },
  maintenanceImage: {
    width: '650px',
    maxWidth: '100%',
    margin: '127px 0 87px',

    '@media (max-width: 767px)': {
      margin: '80px 0 65px',
    },
  },
});

export default styles;
